import { useState, useEffect } from "react";

const isWindowTabletWidth = () => globalThis.document.documentElement.clientWidth >= 576 && globalThis.document.documentElement.clientWidth <= 768;

const useTabletChecker = () => {
  const [isTablet, setIsTablet] = useState(isWindowTabletWidth);
  useEffect(() => {
    const handleResize = () => setIsTablet(isWindowTabletWidth);
    globalThis.addEventListener("resize", handleResize);
    return () => globalThis.removeEventListener("resize", handleResize);
  }, []);
  return isTablet;
};

export default useTabletChecker;
